// Header.server.jsx (Componente estático)
"use server"; // Asegúrate de que esto esté al principio del archivo si lo haces un componente de servidor.

import ClientSideHeader from '../components/Header.client'; 
import Switch from '../components/Switch.client';

const Header = ({ theme, toggleTheme}) => {
 
  return (
    <header>
      {/* Todo lo estático, como el logo, el enlace a la página de inicio, etc. */}
      <nav className="bg-transparent dark:bg-transparent border-gray-200 relative">
        <div className="flex items-center justify-between p-4">
          <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
            <img
              src="https://storage.googleapis.com/drago-imagenes-bucket/favicon.ico"
              className="h-10"
              alt="Dravvt logo"
            />
            <span className="self-center text-2xl font-bold whitespace-nowrap dark:text-blue-100 text-neutral-950 hover:text-blue-600">
              Dravvt
            </span>
          </a>
          <div className="block w-auto" id="navbar-multi-level">
            <ul className="flex font-medium p-4 md:p-0 mt-4 rounded-lg bg-transparent dark:bg-transparent md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-transparent">
              <li className= "block" >
                 <Switch theme={theme} toggleTheme={toggleTheme} />
              </li>
              <li>
                <a
                  href="/"
                  className="hidden py-2 px-3 md:block  text-neutral-950 bg-gray-100 dark:text-blue-100 dark:bg-transparent hover:text-blue-600 dark:hover:text-blue-600 rounded bg-transparent md:p-0"
                  aria-current="page"
                >
                  Home 
                </a>
              </li>
              <li>
                <a
                  href="/blog"
                  className="hidden py-2 px-3 md:block text-neutral-950 bg-gray-100 dark:text-blue-100 dark:bg-transparent hover:text-blue-600  dark:hover:text-blue-600 rounded bg-transparent md:p-0"
                >
                  Blog 
                </a>
              </li>
              <li>
                <button
                  id="dropdownButton" 
                  className="block py-2 px-3 text-neutral-950 bg-gray-100 dark:text-blue-100 dark:bg-transparent hover:text-blue-600 rounded  dark:hover:text-blue-600 bg-transparent md:p-0"
                >
                  Menu ~
                   </button>

                  
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Aquí llamamos al ClientSideHeader para manejar lo dinámico */}
     
      <ClientSideHeader theme={theme} toggleTheme={toggleTheme} />
       
    </header>
  );
};

export default Header;
